import React from 'react';
import './index.scss';

import bannerLeft from '../../assets/Images/banner-left.png'
import bannerRight from '../../assets/Images/banner-right.png'


interface OwnProps {
  bannerSrc: any
}

class SmallBanner extends React.Component<OwnProps> {
  
  // state:any
  
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     banner: this.props.bannerSrc
  //   }
  // }

  render () {
    return (
      <>
        <div className="small-banner">
          <img src={this.props.bannerSrc}/>
        </div>
      </>
    );
  }
}

export default SmallBanner